import React, { useState, useEffect } from 'react'
import UI from './UI'
import { auth, db } from '../utils/firebase'

export default function Nav() {

    const [open, setOpen] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [renderer, setRenderer] = useState(0);
    const [affiliate, setAffiliate] = useState(null);
    const size = useWindowSize();

    useEffect(() => {
        getAuth();
    },[])

    useEffect(() => {
        if(loggedIn) {
            getAffiliateStatus();
        }
    },[loggedIn])

    const getAuth =()=> {
        auth.onAuthStateChanged(u => {
            setLoggedIn(u ? true : false);
        });
    }

    const logout =async ()=> {
        await auth.signOut();
        window.location = '/signup';
    }

    const getAffiliateStatus =async ()=> {
        const snap = await db.collection('affiliates').doc(auth.currentUser.uid).get();
        if(snap.exists)
            setAffiliate(snap.data());
    }

    if(window.location.pathname === '/')
        return null;

    return <UI 
    logout={logout} 
    open={open}
    setOpen={setOpen}
    loggedIn={loggedIn}
    renderer={renderer}
    setRenderer={setRenderer}
    size={size}
    affiliate={affiliate}/>;
}

function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });
    useEffect(() => {
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }
      // Add event listener
      window.addEventListener("resize", handleResize);
      // Call handler right away so state gets updated with initial window size
      handleResize();
      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
}